import {Component, forwardRef, Input, OnChanges, OnInit, ViewEncapsulation} from '@angular/core';
import {NzMessageService} from "ng-zorro-antd/message";
import {cloneDeep} from "lodash";
import {NzMarks} from "ng-zorro-antd/slider";
import {DecimalPipe} from "@angular/common";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import { AbstractControlComponent } from "../../../classes/abstract-control.component";

@Component({
  selector: 'vss-ui-range-number',
  templateUrl: './range-number.component.html',
  styleUrls: ['./range-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeNumberComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None,
})
export class RangeNumberComponent extends AbstractControlComponent<number[]> implements OnInit, ControlValueAccessor{
  @Input() classes = ''
  @Input() csPlaceHolder = 'Từ - Đến'
  @Input() prefix = ''
  @Input() suffix = ''
  @Input() minValue: number = 0
  @Input() maxValue: number = 100
  @Input() showMessageInvalid = false
  @Input() showDialogMessageInvalid = true
  valueInput = ''
  messageInvalid = ''
  sliderValues: number[] = []

  get marksValue(): NzMarks {
    const decimalPipe = new DecimalPipe('en-US')
    const data: NzMarks = {
      [this.minValue]: `${this.prefix}${decimalPipe.transform(this.minValue, '1.0-2')}${this.suffix}`,
      [this.maxValue]: `${this.prefix}${decimalPipe.transform(this.maxValue, '1.0-2')}${this.suffix}`,
    }
    this.sliderValues?.forEach(x => {
      data[x] = {
        style: {
          color: '#ee0033'
        },
        label: `<span>${this.prefix}${decimalPipe.transform(x, '1.0-2')}${this.suffix}</span>`
      }
    })
    return data
  }

  constructor(
    private messageService: NzMessageService
  ) {
    super();
  }

  writeValue(obj: any) {
    this.sliderValues = cloneDeep(obj)
    if(((!obj || !this.controlValue) && obj != this.controlValue) || ((obj || this.controlValue) && this.controlValue?.some((x, k) => obj[k] != x)) ) {
      super.writeValue(obj);
      this.onModelChange(obj)
    }
  }

  ngOnInit(): void {
    this.sliderValues = cloneDeep(this.controlValue)
  }

  inputChange() {
    const value = this.valueInput.replace(new RegExp(` ${this.prefix}${this.suffix}`, 'g'), '')
    if(value) {
      let values = value.split('-').filter((_, k) => k < 2).map((x, k) => {
        if(x) return parseInt(x)
        return k == 0 ? this.minValue || 0 : parseInt(value.split('-')[0] || `${this.minValue || 0}`)
      })
      this.changeValueRange(values)
    } else {
      this.writeValue(null)
    }
  }

  progressInputValue(values: number[]) {
    if(values.length == 1) {
      values.push(values[0])
    }
    if(values[0] < this.minValue) {
      values[0] = this.minValue
    }
    if(values[1] > this.maxValue) {
      values[1] = this.maxValue
    }
    if(values[0] > values[1]) {
      this.messageInvalid = 'Số bắt đầu không thể lớn hơn số kết thúc'
      // values[1] = values[0]
    }
    if(this.messageInvalid && this.showDialogMessageInvalid) {
      this.messageService.error(this.messageInvalid)
    }
    this.valueInput = `${this.prefix}${values[0]}${this.suffix} - ${this.prefix}${values[1]}${this.suffix}`
  }

  changeValueRange(values: number[]) {
    if(!values.length) {
      this.writeValue(null)
      return
    }
    this.progressInputValue(values)
    this.writeValue(values)
  }

  keyupEvent(e: KeyboardEvent) {
    if(/[\d- ]/g.test(e.key)) {

    }
  }

  keypressEvent(e: KeyboardEvent) {
    if(!/[\d- ]/g.test(e.key)) {
      e.preventDefault()
    }
  }
}
